export class WorkItemSubmitted {
    constructor(public workItemId: string, public title: string) { }

    static eventName() { return 'WorkItemSubmitted'; }

    eventName = WorkItemSubmitted.eventName;
}
